import React from "react";
import styles from "./index.module.scss";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";

const ProductHygieneShowcase = ({ productHygieneShowcaseData }) => {
  const { locale } = useRouter()

  if (!productHygieneShowcaseData) return null;
  
  const {
      heading,
      description,
      images = [],
      showMarginBelow=false,
  } = productHygieneShowcaseData;
  
  let marginClass = showMarginBelow ? styles.sectionmarginBelow : styles.section;
  
  return (
    <section className={marginClass}>
      <div className={styles.container}>
        <div className={styles.imageRow}>
          {images.map((img, index) => {

            const { imageUrl, alt } = img.fields || {};
            if (!imageUrl) return null;
            return (
                <div className={styles.card} key={index}>
                  <img
                    src={imageUrl}
                    alt={alt || ""}
                    className={styles.image}
                  />
                </div>
              )
          })}
        </div>
        <div className={styles.textWrapper}>
          {heading && (
              <h2 className={styles.title}>{heading}</h2>
          )}
          {description && (
            <div className={styles.description}>
              {renderRichText(description, locale)}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
export default ProductHygieneShowcase;
